// Placeholder toaster component
export function Toaster() {
  return null;
}